import { Bff } from 'core/services';
import * as useCases from 'core/use-cases';

import type { RequestAction } from '../@types';

import { resourceResolver } from './resource-resolver';

/**
 * Apply type guard and type assertions for the
 * presenterResponse and presenterRequest functions
 *
 */
export function getResource(action: RequestAction) {
  if (
    useCases.cart.actions.cartFetchForGiftsCheck.request.match(action) ||
    useCases.cart.actions.cartFetch.request.match(action) ||
    useCases.cart.actions.lastCartFetch.request.match(action) ||
    useCases.cart.actions.cartCurrentDeliveryFetch.request.match(action) ||
    useCases.cart.actions.cartSetShippingModelFetch.request.match(action) ||
    useCases.cart.actions.clearCouponFetch.request.match(action) ||
    useCases.cart.actions.itemAddFetch.request.match(action) ||
    useCases.cart.actions.itemDeleteFetch.request.match(action) ||
    useCases.cart.actions.itemUpdateFetch.request.match(action) ||
    useCases.cart.actions.setCouponFetch.request.match(action) ||
    useCases.checkout.actions.createOrderFetch.request.match(action) ||
    useCases.checkout.actions.paymentDetailFetch.request.match(action) ||
    useCases.checkout.actions.promotionFetch.request.match(action) ||
    useCases.checkout.actions.processFetch.request.match(action) ||
    useCases.combo.actions.comboPost.request.match(action) ||
    useCases.shippingModel.actions.availableDeliveryModesFetch.request.match(action) ||
    useCases.shippingModel.actions.currentDeliveryModeFetch.request.match(action)
  ) {
    return resourceResolver<Bff.CartResponse>(action);
  }

  if (useCases.productDetail.actions.productDetailFetch.request.match(action)) {
    return resourceResolver<Bff.ProductDetailResponse>(action);
  }

  if (
    useCases.catalog.actions.catalogFetch.request.match(action) ||
    useCases.catalog.actions.catalogNextPageFetch.request.match(action) ||
    useCases.catalog.actions.searchPreviousFetch.request.match(action) ||
    useCases.search.actions.searchFetch.request.match(action) ||
    useCases.showcases.actions.showcasesFetch.request.match(action)
  ) {
    return resourceResolver<Bff.ProductResponse>(action);
  }

  if (useCases.checkout.actions.paymentMethodsFetch.request.match(action)) {
    return resourceResolver<Bff.PaymentPlansResponse>(action);
  }

  if (useCases.user.actions.creditFetch.request.match(action)) {
    return resourceResolver<Bff.ResellerCreditResponse>(action);
  }

  if (useCases.user.actions.userFetch.request.match(action)) {
    return resourceResolver<Bff.AuthDetailResponse>(action);
  }

  if (useCases.user.actions.userResaleIntention.request.match(action)) {
    return resourceResolver<Bff.AuthDetailResponse>(action);
  }

  if (useCases.order.actions.orderFetch.request.match(action)) {
    return resourceResolver<Bff.OrderPayloadResponse>(action);
  }

  if (useCases.user.actions.userBuyIntentionFetch.request.match(action)) {
    return resourceResolver<Bff.BuyIntentionResponse>(action);
  }

  if (useCases.combo.actions.comboFetch.request.match(action)) {
    return resourceResolver<Bff.ComboResponse>(action);
  }

  if (useCases.user.actions.cyclesFetch.request.match(action)) {
    return resourceResolver<Bff.CyclesResponse>(action);
  }

  if (useCases.user.actions.changeCycle.request.match(action)) {
    return resourceResolver<Bff.ChangeCycleResponse>(action);
  }

  if (useCases.showcases.actions.availableShowcasesFetch.request.match(action)) {
    return resourceResolver<Bff.AvailableShowcasesResponse>(action);
  }

  if (
    useCases.content.actions.starlinkPageFetch.request.match(action) ||
    useCases.content.actions.starlinkContentFetch.request.match(action)
  ) {
    return resourceResolver<Bff.StarlinkResponse>(action);
  }

  if (useCases.catalog.actions.getResellerAvailableCatalogs.request.match(action)) {
    return resourceResolver<Bff.ResellerAvailableCatalogs>(action);
  }

  if (useCases.user.actions.incentiveCampaignsListFetch.request.match(action)) {
    return resourceResolver<Bff.IncentiveCampaignsResponse>(action);
  }

  throw new Error(`Action type is not mapped to any BFF endpoint`);
}
